import { Redirect, Route } from "react-router-dom";

const ProtectedRoute = ({ component: Component, isLogged, ...rest }) => {
  const loginDetails = JSON.parse(localStorage.getItem("credentials"));
  return (
    <Route
      {...rest}
      render={(props) => {
        if (isLogged || loginDetails?.center) {
          return <Component {...props} />;
        } else {
          return <Redirect to="/login" />;
        }
      }}
    />
  );
};

export default ProtectedRoute;
